<template>
  <div class="layout-wrapper layout-blank">
    <RouterView />
  </div>
</template>

<script>
</script>

<style scoped>

</style>
